import { get } from 'lodash';

function applyParameters(template, params) {
  return template.replace(/\{(\d+)}/g, (match, index) => params[parseInt(index, 10)]);
}

function getTopMMInRanking(ranking) {
  const modelYear = get(ranking, 'segmentRatings[0].modelYear');
  const modelName = get(modelYear, 'modelName');
  const makeName = get(modelYear, 'makeName');

  return `${makeName} ${modelName}`;
}

function getTopVehiclesInRankings(rankings, type) {
  const results = {};

  rankings.forEach(ranking => {
    const subsegment = ranking.subsegment || type;
    const topVehicle = getTopMMInRanking(ranking);
    let key;

    if (ranking.market && ranking.market.includes('Luxury')) {
      key = `Luxury ${subsegment}`;
    } else {
      key = subsegment;
    }
    results[key] = topVehicle;
  });

  return results;
}

function getFaqEntries({ topVehiclesInRankings, faqContent }) {
  return faqContent.children().map(entry => ({
    answer: applyParameters(
      entry.metadata('answer').value(),
      entry
        .metadata('answerSubsegments')
        .value()
        .split('|')
        .map(segment => topVehiclesInRankings[segment])
    ),
    question: entry.metadata('question').value(),
  }));
}

export function getTypeFaqsContent({ vehicleEditorialRankings, faqContent, typeSlug }) {
  if (!vehicleEditorialRankings || !typeSlug) return [];

  const topVehiclesInRankings = getTopVehiclesInRankings(vehicleEditorialRankings, typeSlug);

  return getFaqEntries({ topVehiclesInRankings, faqContent }).filter(({ answer }) => !!answer);
}
